<template>
	<div class="content">
		<div class="card modern">
			<div class="card-body">
				<h1 style="font-size: 20px">FLUXO DE CAIXA/COMPETÊNCIA</h1>

				<div class="row mb-3 mt-4">
					<div class="col-md-8 col-12 text-center-mobile">

						<select class="btn btn-transparente" @change="reload()" v-model="type" style="display: inline-block;">
							<option value="caixa">Caixa</option>
							<option value="competencia">Competência</option>
						</select>
						<select class="btn btn-transparente" @change="reload()" v-model="account_id" style="display: inline-block;">
							<option value="">Todas as contas</option>
							<option v-for="account of accounts" :value="account.id">{{ account.name }}</option>
						</select>
						<div class="d-block" style="margin-left:-9px;">
							<input id="sub-categorias" v-model="subcategorias" @change="toggleSubCategorias" class="styled-checkbox" type="checkbox">
							<label for="sub-categorias" style="vertical-align: top; line-height: 25px;">
								Mostrar sub-categorias
							</label>
						</div>
					</div>
					<div class="col-md-4 col-12 text-right text-center-mobile">
						<button class="btn btn-secondary text-grey" @click="prev()"><i class="now-ui-icons arrows-1_minimal-left text-white"></i></button>
						<button class="btn btn-secondary text-grey" @click="next()"><i class="now-ui-icons arrows-1_minimal-right text-white"></i></button>
					</div>
				</div>
				<div class="row small-letters p-4" style="overflow-x: auto; overflow-y: hidden;">
					<table class="table flow-table-bordered-strong text-center">
						<thead>
							<th style="width: 20%; border-top: 0 !important; border-left: 0"></th>
							<th style="width: 10%;" class="text-center" :class="{ 'bg-yellow': flow.current_month }" v-for="flow of flow">{{ flow.period }}</th>
						</thead>
						<tbody>
							<tr>
								<td class="text-left">Saldo inicial</td>
								<td v-for="flow of flow" :class="{ 'text-expense': flow.total_prev < 0 }">{{ flow.total_prev | currencyBrl }}</td>
							</tr>
							<tr style="background-color: #dff0d8">
								<td class="text-left">Receitas</td>
								<td v-for="flow of flow">{{ flow.total_revenue | currencyBrl }}</td>
							</tr>
							<tr v-for="category of categories">
								<template v-if="category.type == 'r'">
									<td class="text-left">{{ category.name }}</td>
									<td v-for="flow of flow">{{ flow.revenues[category.id] ? flow.revenues[category.id].value : 0 | currencyBrl }}</td>
								</template>
							</tr>
							<tr style="background-color: #f2dede">
								<td class="text-left">Despesas</td>
								<td v-for="flow of flow">{{ flow.total_expense | currencyBrl }}</td>
							</tr>
							<tr v-for="category of categories">
								<template v-if="category.type == 'e'">
									<td class="text-left">{{ category.name }}</td>
									<td v-for="flow of flow">{{ flow.expenses[category.id] ? flow.expenses[category.id].value : 0 | currencyBrl }}</td>
								</template>
							</tr>
							<tr style="background-color: #f7f7f7">
								<td class="text-left">Saldo do período</td>
								<td v-for="flow of flow">{{ flow.geracao | currencyBrl }}</td>
							</tr>
							<tr style="background-color: #eee">
								<td class="text-left "><strong>Saldo total</strong></td>
								<td v-for="flow of flow" :class="{ 'text-expense':flow.total < 0 }"><strong>{{ flow.total | currencyBrl }}</strong></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Order from '@/models/Order'
	import OrderService from '@/services/OrderService'
	import AccountService from '@/services/AccountService'
	import moment from 'moment'

	export default {
		data() {
			return {
				flow: [],
				subcategorias: false,
				type: 'caixa',
				account_id: '',
				loading: false,
				date: moment(),
				categories: [],
				accounts: []
			}
		},
		methods: {
			load() {

				let params = '?type=' + this.type + '&date=' + this.date.format('YYYY-MM-DD');
				
				if(this.account_id) {
					params += '&account_id=' + this.account_id
				}

				if(this.subcategorias) {
					params += "&sub_categories=true"
				}

				OrderService.flow(params).then(res => {
					this.flow = res.data.flow
					this.categories = res.data.categories
				})
				.catch(err => {
					console.error(err)
				})
			},
			reload(type) {
				this.load()
			},
			next() {
				this.date = this.date.add(1, 'month')
				this.load();
			},

			prev() {
				this.date = this.date.subtract(1, 'month')
				this.load();
			},
			loadAccounts() {
				AccountService.load().then(res => {
					this.accounts = res.data
				})
			},
			toggleSubCategorias(event) {
				this.load()
			}
		},
		mounted() {
			this.loadAccounts()
			this.load()
		}
	}
</script>

<style>
.flow-table-bordered-strong {
	border: 0;
}

.flow-table-bordered-strong th, .flow-table-bordered-strong  td {
	border: 1px solid #ddd;	
}

.small-letters {
	font-size: 14px;
}

.bg-yellow {
	background-color: #fffbe5;
}
</style>